import React, { useEffect } from 'react';
import { ButtonLink, FullModal } from '@sbt-web/ui';
import styles from './index.module.scss';
import {
  trackModalDismiss,
  trackModalInterest,
  trackModalView,
} from '../tracking';
import { COUNT_STORAGE_KEY } from '@client/components/Adv/PremiumSavedSearch/shared';

type Props = {
  open: boolean;
  onClose: () => void;
};

const updateDisplayCount = (): void => {
  const displayCount: number = Number.parseInt(
    localStorage.getItem(COUNT_STORAGE_KEY) ?? '0'
  );
  localStorage.setItem(COUNT_STORAGE_KEY, `${displayCount + 1}`);
};

const PremiumSavedSearchModal = ({ open, onClose }: Props) => {
  useEffect(() => {
    if (open) {
      trackModalView();
      updateDisplayCount();
    }
  }, [open]);

  const handleInterest = () => {
    trackModalInterest();
  };
  return (
    <FullModal
      open={open}
      onClose={() => {
        trackModalDismiss();
        onClose();
      }}
      title={'Notifiche premium'}
      size={'small'}
      actions={[
        <ButtonLink
          classes={[styles['cta']]}
          key={'confirm'}
          href={`${process.env.NEXT_PUBLIC_AREARISERVATA_BASE_URL}/ricerche?from=listing-premium-searches`}
          onClick={handleInterest}
        >
          Vai alle ricerche salvate
        </ButtonLink>,
      ]}
    >
      <img
        className={styles['image']}
        alt=""
        height="180"
        width="240"
        decoding="async"
        src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/illustrations/SavedSearches.svg`}
      />
      <h3 className={`headline-5 ${styles['head']}`}>
        I migliori affari, prima di tutti
      </h3>
      <p className={'body-text'}>
        Le <b>Notifiche Premium</b> ti permettono di ricevere in anteprima, e
        più frequentemente rispetto a quelle standard, gli avvisi relativi alla
        tua ricerca salvata.
        <br />
        Attiva Notifiche Premium a partire da <b>3,99 €</b> per ricerca.
      </p>
    </FullModal>
  );
};

export { PremiumSavedSearchModal, updateDisplayCount };
